import {Injectable, EventEmitter} from '@angular/core';
import {OrderManager} from 'src/app/data/manager/order/order/order.manager';
import {LocationManager} from '../../data/manager/location/location.manager';
import {AddressManager} from '../../data/manager/customer/address/address.manager';
import {CallCenterManager} from '../../data/manager/call-center/call-center.manager';

export enum AddressTagsEnum { HOME = 'Casa', OFFICE = 'Oficina', OTHER = 'Otro' }

@Injectable({
  providedIn: 'root',
})
export class AddressesModalVm {

  openNewAddress = new EventEmitter();

  constructor(
    private locationManager: LocationManager,
    private addressManager: AddressManager,
    private callCenterManager: CallCenterManager,
    private orderManager: OrderManager,
  ) {}

  updateDeliveryType(address) {
    this.locationManager.updateDeliveryType(address);
  }

  setDeliveryAddress(address) {
    this.addressManager.setDeliveryAddress(address);
  }

  callCenterCustomer() {
    return this.callCenterManager.getCustomer();
  }

  getAddress() {
    return this.addressManager.get();
  }

  selectAddressDefault(idAddress) {
    return this.addressManager.selectAddressDefault(idAddress);
  }

  getDeliveryTypeTimeFromService(citySelected: string): void {
    this.orderManager.getDeliveryTypeTimeFromService(citySelected).subscribe();
  }
}
